import extractDataFromFirebaseCredential from 'lib/extractDataFromFirebaseCredential';

import User from 'types/User';
import { authAndSignInWithProvider, AuthProviders } from 'lib/Auth';

export default async function signInWithFacebook(): Promise<User> {
  const credential = await authAndSignInWithProvider(AuthProviders.Facebook);
  return extractDataFromFirebaseCredential(credential);
}
